// extracted by mini-css-extract-plugin
export default {"tabsRow":"CarouselCardCollapse_tabsRow__NXUxW","tabs":"CarouselCardCollapse_tabs__h6-JM"};